<script lang="ts">
	import { getStructuredDataScript } from "@utils/getStructuredDataScript.js";
	import type { Product } from "@core/schema/Product.js";
	import { deliveryCommonPrice } from "@core/schema/deliveryCommonPrice.js";
	import { appName } from "@core/schema/names/appName.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { product }: { product: Product } = $props();
	const { FILE_BUCKET_URL_MAP, WEB_URL } = getGlobalSettings();
	const { pagePath, tenant } = getGlobalTemplateProps();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{@html getStructuredDataScript({
		"@context": "https://schema.org",
		"@type": "Product",
		name: product.name,
		description: product.description,
		image: product.images.map((image) => getUploadedFilePath(image, FILE_BUCKET_URL_MAP)),
		url: `${WEB_URL}${pagePath[tenant.locale]}`,
		brand: {
			"@type": "Brand",
			name: appName,
		},
		offers: {
			"@type": "Offer",
			availability: product.active ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
			price: product.price,
			priceCurrency: "CZK",
			shippingDetails: {
				"@type": "OfferShippingDetails",
				shippingRate: {
					"@type": "MonetaryAmount",
					value: deliveryCommonPrice,
					currency: "CZK",
				},
				shippingDestination: [
					{
						"@type": "DefinedRegion",
						addressCountry: "CZ",
					},
				],
			},
			hasMerchantReturnPolicy: {
				"@type": "MerchantReturnPolicy",
				returnPolicyCategory: "https://schema.org/MerchantReturnNotPermitted",
				applicableCountry: "CZ",
			},
		},
	})}
</svelte:head>
